/**
 * Creates an Intl.NumberFormat instance for the given currency code.
 *
 * Uses locale 'en' with currency style and two decimal places.
 * Supports any ISO 4217 currency code (e.g. 'PHP', 'USD').
 */
export const currencyFormatter = (currency: string): Intl.NumberFormat =>
  new Intl.NumberFormat('en', {
    maximumFractionDigits: 2,
    minimumFractionDigits: 2,
    style: 'currency',
    currency,
  });
